import React, {useCallback, useEffect, useState} from 'react';


const MySelect = ({name, items, callBack, defaultValue}) => {
    const [options, setoptions] = useState([]);
    const [selected, setselected] = useState(defaultValue);

    const changeSelect = useCallback(
        (e) => {
            e.preventDefault();
            if (e.target.value) {
                setselected(e.target.value);
                const valToSend = {[name]: e.target.value};
                callBack(valToSend);
            }
        },
        [callBack, name],
    );

    useEffect(() => {
        const optionsRes = items.enum.reduce(
            (res, elem, idx) => [...res, {val: elem, desc: items.enumDesc[idx]}],
            [],
        );
        setoptions(optionsRes);
    }, [items]);

    return (
        <select value={selected} onChange={changeSelect}>
            {options.map((elem, idx) => (
                <option key={idx} value={elem.val}>
                    {elem.desc}
                </option>
            ))}
        </select>
    );
};

export default MySelect;
